/**
 * Needs attention: the conditions an administrator has to act on, as one
 * compact band. Each line is a count and a button; pressing it shows those
 * policies in the same table as everything else. It is not a dashboard and
 * must not grow into one: the table below is the work.
 */
import { GroupCard } from '../../../shared/GroupCard';
import type { LibraryView } from './libraryQuery';
import { ATTENTION_VIEWS, VIEW_LABEL } from './libraryText';
import type { AttentionCounts } from './useLibrary';
import styles from './Library.module.css';

const TONE: Partial<Record<LibraryView, string>> = {
  reviewOverdue: styles.attentionDanger!,
  reviewDue: styles.attentionWarn!,
  ownerUnassigned: styles.attentionWarn!,
  ownerInactive: styles.attentionWarn!,
};

export function AttentionSummary({ views, counts, loading, current, onOpen }: {
  /** The conditions this person may open. */
  views: readonly LibraryView[];
  counts: AttentionCounts | undefined;
  loading: boolean;
  current: LibraryView;
  onOpen: (view: LibraryView) => void;
}) {
  const shown = ATTENTION_VIEWS.filter((v) => views.includes(v));
  if (shown.length === 0) return null;
  return (
    <GroupCard title="Needs attention" list level={2}>
      <div className={styles.attention}>
        {shown.map((view) => {
          const n = counts?.[view];
          const known = typeof n === 'number';
          return (
            <button
              key={view}
              type="button"
              className={current === view ? `${styles.attentionItem} ${styles.attentionOn}` : styles.attentionItem}
              aria-pressed={current === view}
              onClick={() => onOpen(view)}
            >
              <span>{VIEW_LABEL[view]}</span>
              <span className={`${styles.attentionCount} tnum ${known && n > 0 ? TONE[view] ?? '' : styles.attentionNone}`}>
                {loading ? '…' : known ? n.toLocaleString('en-US') : '—'}
              </span>
            </button>
          );
        })}
      </div>
    </GroupCard>
  );
}
